<template>
  <div>
    <Dropzone
      :ref="id"
      :id="id"
      class="file-drop"
      :dropzoneOptions="dzOptions"
      :url="`${apiUrl}/upload`"
      :useCustomDropzoneOptions="true"
      @isLoading="$emit('isLoading', $event)"
      @vdropzone-sending="onSending"
      @vdropzone-success="onSuccess" />
  </div>
</template>

<script>
import Dropzone from './Dropzone'
import { apiUrl } from '@config'

const optional = (key, value) => value ? ({ [key]: value }) : {}

export default {
  components: { Dropzone },
  props: {
    accept: {
      type: String,
      default: '.docx',
    },
    data: {
      default: () => ({}),
      type: Object,
    },
    id: {
      default: 'dropzone',
      type: String,
    },
    init: {
      default() {
        return function init() {
          this.on('complete', (file) => {
            this.removeFile(file)
          })
        }
      },
      type: Function,
    },
    isPublic: {
      default: false,
      type: Boolean,
    },
    message: {
      default: null,
      type: String,
    },
    options: {
      default: () => ({}),
      type: Object,
    },
    type: {
      default: null,
      type: String,
    },
  },
  data() {
    return {
      apiUrl,
      defaultOptions: {
        init: this.init,
        maxFilesize: 1,
        paramName: 'uri',
        uploadMultiple: false,
      },
    }
  },
  computed: {
    formData() {
      return {
        ...this.data,
        scope: this.isPublic
          ? 'PUBLIC'
          : 'PRIVATE',
        type: this.type,
      }
    },
    dzOptions() {
      return {
        ...this.defaultOptions,
        ...this.options,
        ...optional('acceptedFiles', this.accept),
        ...optional('dictDefaultMessage', this.message),
      }
    },
  },
  methods: {
    addFile(file) {
      this.$refs[this.id].addFile(file)
    },
    removeAllFiles(cancelIfNecessary) {
      this.$refs[this.id].removeAllFiles(cancelIfNecessary)
    },
    onSuccess({ xhr }) {
      try {
        this.$emit('success', JSON.parse(xhr.response))
      } catch (error) {
        this.$emit('success')
      }
    },
    onSending(file, xhr, formData) {
      Object
        .entries(this.formData)
        .forEach(([key, value]) => {
          formData.append(key, value)
        })
    },
  },
}
</script>

<style lang="scss">
.dropzone {
  min-height: 50px !important;
  padding: 0 !important;
}

.dz-upload {
  background-color: $success;
  display: block;
  height: 10px;
  width: 0%;
}
</style>
